module.exports = __webpack_public_path__ + "static/media/bloodPressure.74d076f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/bloodPressure.svg
// module id = 1459
// module chunks = 0